import React from 'react'

const Tools = () => {
  return (
    <div className="skills_content">
      <h3 className="skills_title"> <i class='bx bx-wrench'></i> Tools & DevOps</h3>

      <div className="skills_list">
        <div className="skills_item"> Git</div>
        <div className="skills_item"> GitHub</div>
        <div className="skills_item"> Docker</div>
        <div className="skills_item"> Azure</div>
        <div className="skills_item"> Jira</div>
        <div className="skills_item"> N8N</div>
      </div>
    </div>
  )
}
export default Tools